import { type AnimationControlValue, AnimationRadioGroup } from './AnimationRadioGroup';
import { delayOptions, type AnimationDelay } from './animationControlOptions';

type AnimationDelayControlProps = {
    value?: AnimationControlValue<AnimationDelay>;
    defaultValue?: AnimationControlValue<AnimationDelay>;
    onChange?: (value: AnimationControlValue<AnimationDelay>) => void;
};

const AnimationDelayControl = (props: AnimationDelayControlProps) => (
    <AnimationRadioGroup
        name='delay'
        options={delayOptions}
        className='display-flex flex-wrap justify-content-center'
        {...props}
    />
);

export default AnimationDelayControl;
